import _ from 'lodash';

function AdminCtrl($rootScope, $scope, $timeout, $state, $stateParams, $compile, $ngConfirm, $sce, toastr, AppSettings, AppContextService, UserService, PlanService, PlayerService, DashboardService, AdminService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  vm.adminGoMenu = function(adminMenu) {
    var params = angular.copy($stateParams);
    params.admin_menu = adminMenu;

    $state.go('Service.admin', params);
  }

  if (!$stateParams.admin_menu) {
    vm.adminGoMenu('team_search');
  }
  
  PlanService.getTrainingMeta()
    .then(function (res) {
      vm.trainingMetaMovements = res.data.movements;
    })
    .catch(function (error) {
      console.log('ERROR ' + error);
    });

  // 컨텐츠 등록 설정
  vm.setContents = {
    range: 'all'    // 등록 범위 - all: 전체, team: 특정팀, user: 특정 사용자, coach: 전체 지도자
  };

  vm.setContents2 = {
    range: 'all'    // 등록 범위 - all: 전체, team: 특정팀, user: 특정 사용자, coach: 전체 지도자
  };

  $scope.$watch('vm.setContents', function(newVal, oldVal) {
    vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = vm.modalTeam4 = null;
    vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = vm.modalTeam42 = null;
    vm.modalPlayers = vm.selectedPlayer = null;

    if (newVal.range === 'team') {
      vm.showSearchModal = true;
      vm.searchModalMode = 'searchTeam';
    } else if (newVal.range === 'user') {
      vm.showSearchModal = true;
      vm.searchModalMode = 'searchPlayer';
    } else {
      vm.showSearchModal = false;
    }
  }, true);

  $scope.$watch('vm.setContents2', function(newVal, oldVal) {
    vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = vm.modalTeam4 = null;
    vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = vm.modalTeam42 = null;
    vm.modalPlayers = vm.selectedPlayer = null;

    if (newVal.range === 'team') {
      vm.showSearchModal = true;
      vm.searchModalMode = 'searchTeam';
    } else {
      vm.showSearchModal = false;
    }
  }, true);

  // 선수 선택 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.modalContinents = data.list;
  });

  // 선수 선택 -  대륙 변경
  $scope.$watch('vm.modalTeamContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries = res.data.list;
        vm.modalTeams1 = vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  국가 변경
  $scope.$watch('vm.modalTeamCountry', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: newVal.id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams1 = res.data.list;
          vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
        }).catch(function(err) {
          console.log(err);
        });
    }
  });

  // 선수 선택 -  팀 1단계 변경
  $scope.$watch('vm.modalTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: vm.modalTeamCountry.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams2 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams3 = vm.modalTeams4 = null;

      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  팀 2단계 변경
  $scope.$watch('vm.modalTeam2', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: vm.modalTeamCountry.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams3 = res.data.list;
        vm.modalTeams4 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 선수 선택 -  팀 3단계 변경
  $scope.$watch('vm.modalTeam3', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: vm.modalTeamCountry.id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams4 = res.data.list;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  var selectedTeam = {};
  // 선수 선택 -  팀 4단계 변경
  $scope.$watch('vm.modalTeam4', function (newVal, oldVal) {
    if (newVal) {
      // vm.joinData.agency_team_id = newVal.id;
      // vm.joinData.agency_team_name = newVal.name;
      selectedTeam.id = newVal.id;
      selectedTeam.name = newVal.name;

      // 선수 검색
      var data = {
        all: 'Y',
        team_id: newVal.id
      };

      PlayerService.getPlayers(data)
        .then(function (res) {
          vm.modalPlayers = res.data.players;
        })
        .catch(function (error) {
          console.log('ERROR ', error)
        });
    }
  });

  // 팀 선택 - 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.modalContinents2 = data.list;
  });

  // 팀 선택 -  대륙 변경
  $scope.$watch('vm.modalTeamContinent2', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries2 = res.data.list;
        vm.modalTeams12 = vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  국가 변경
  $scope.$watch('vm.modalTeamCountry2', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: newVal.id
      };
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams12 = res.data.list;
          vm.modalTeams22 = vm.modalTeams32 = vm.modalTeams42 = null;
        }).catch(function(err) {
          console.log(err);
        });
    }
  });

  // 팀 선택 -  팀 1단계 변경
  $scope.$watch('vm.modalTeam12', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: vm.modalTeamCountry2.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams22 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams32 = vm.modalTeams42 = null;

      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 2단계 변경
  $scope.$watch('vm.modalTeam22', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: vm.modalTeamCountry2.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams32 = res.data.list;
        vm.modalTeams42 = null;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 3단계 변경
  $scope.$watch('vm.modalTeam32', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: vm.modalTeamCountry2.id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams42 = res.data.list;
      }).catch(function(err) {
        console.log(err);
      });
    }
  });

  // 팀 선택 -  팀 4단계 변경
  $scope.$watch('vm.modalTeam42', function (newVal, oldVal) {
    if (newVal) {
      vm.modalSelectedTeam = newVal.id;
    }
  });

  // 대시보드 등록 컨텐츠
  vm.dashboardContents = {
    game: {
      videos: [],
      contents: []
    },
    training: {
      videos: [],
      contents: []
    },
    health: {
      videos: [],
      contents: []
    },
    recovery: {
      videos: [],
      contents: []
    }
  };
  vm.dashboardContent = {
    game: {
      video: {},
      content: {}
    },
    training: {
      video: {},
      content: {}
    },
    health: {
      video: {},
      content: {}
    },
    recovery: {
      video: {},
      content: {}
    }
  };
  vm.dashboardContents2 = {
    game: {
      videos: {
        '지도': [],
        '재활': []
      },
      contents: {
        '지도': [],
        '재활': []
      }
    },
    training: {
      videos: {
        '지도': [],
        '재활': []
      },
      contents: {
        '지도': [],
        '재활': []
      }
    }
  };
  vm.dashboardContent2 = {
    game: {
      video: {
        '지도': {},
        '재활': {}
      },
      content: {
        '지도': {},
        '재활': {}
      }
    },
    training: {
      video: {
        '지도': {},
        '재활': {}
      },
      content: {
        '지도': {},
        '재활': {}
      }
    }
  };

  // 대시보드 동영상 삭제
  vm.removeDashboardContent = function(id, coaching) {
    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            DashboardService.remove({
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            }).then(function (res) {
              if (!coaching) {
                vm.getDashboardContents();
              } else {
                vm.getDashboardContents2();
              }
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });
  };

  // 대시보드 컨텐츠 목록
  vm.getDashboardContents = function() {
    var dashboardListData = {
      login_id: vm.appContext.user.login_id
    };
    if ($stateParams.manager_admin_team_id) {
      dashboardListData.team_id = $stateParams.manager_admin_team_id;
    }
    DashboardService.list(dashboardListData)
      .then(function (res) {
        var lists = res.data.lists;
  
        var gameList = _.find(lists, {
          type: '경기'
        });
        vm.dashboardContents.game.videos = gameList.list[0].videos;
        vm.dashboardContents.game.contents = gameList.list[0].contents;
  
        var trainingList = _.find(lists, {
          type: '훈련'
        });
        vm.dashboardContents.training.videos = trainingList.list[0].videos;
        vm.dashboardContents.training.contents = trainingList.list[0].contents;
  
        var healthList = _.find(lists, {
          type: '건강'
        });
        vm.dashboardContents.health.videos = healthList.list[0].videos;
        vm.dashboardContents.health.contents = healthList.list[0].contents;
  
        var recoveryList = _.find(lists, {
          type: '재활'
        });
        vm.dashboardContents.recovery.videos = recoveryList.list[0].videos;
        vm.dashboardContents.recovery.contents = recoveryList.list[0].contents;
      })
      .catch(function(err) {
        toastr.error(err);
      });
  };

  vm.getDashboardContents();

  // 대시보드 영상, 컨텐츠 등록
  vm.setDashboardContent = function (type, type2) {

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type, // game, training, health, recovery
      is_video: type2 === 'video' ? 'Y' : 'N',
      is_admin: vm.setContents.range === 'all' ? 'Y' : 'N',
      title: vm.dashboardContent[type][type2].title,
      subtitle: vm.dashboardContent[type][type2].subtitle && vm.dashboardContent[type][type2].subtitle.name,
      url: vm.dashboardContent[type][type2].url
    };

    if (vm.setContents.range === 'team') {
      if (vm.modalTeam42) {
        data.team_id = vm.modalTeam42.id;
      } else {
        toastr.error('팀을 선택하세요');
        return;
      }
    } else if (vm.setContents.range === 'user') {
      if (vm.selectedPlayer) {
        data.show_user_id = vm.selectedPlayer.user_id;
      } else {
        toastr.error('사용자를 선택하세요');
        return;
      }
    } else if (vm.setContents.range === 'coach') {
      data.show_user_type_id = 2;
    }

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }

    DashboardService.set(data).then(function (res) {
      toastr.success('등록되었습니다.');
      vm.getDashboardContents();
    }, function() {
      toastr.error('등록중 오류가 발생하였습니다.');
    }).catch(function(err) {
      toastr.error('등록중 오류가 발생하였습니다.');
    });
  };

  // 지도자료 컨텐츠 목록
  vm.getDashboardContents2 = function() {
    var dashboardListData = {
      login_id: vm.appContext.user.login_id,
      show_user_type_id: 2
    };
    if ($stateParams.manager_admin_team_id) {
      dashboardListData.team_id = $stateParams.manager_admin_team_id;
    }
    DashboardService.list(dashboardListData)
      .then(function (res) {
        var lists = res.data.lists;

        var temp = {
          game: {
            videos: {
              '지도': [],
              '재활': []
            },
            contents: {
              '지도': [],
              '재활': []
            }
          },
          training: {
            videos: {
              '지도': [],
              '재활': []
            },
            contents: {
              '지도': [],
              '재활': []
            }
          }
        };
  
        var gameList = _.find(lists, {
          type: '경기'
        });
        
        _.forEach(gameList.list[0].videos, function(item) {
          if (item.subtitle.split('지도-').length > 1) {
            item.subtitle = item.subtitle.split('지도-')[1];
            temp.game.videos['지도'].push(item);
          } else if (item.subtitle.split('재활-').length > 1) {
            item.subtitle = item.subtitle.split('재활-')[1];
            temp.game.videos['재활'].push(item);
          }
        });
        _.forEach(gameList.list[0].contents, function(item) {
          if (item.subtitle.split('지도-').length > 1) {
            item.subtitle = item.subtitle.split('지도-')[1];
            temp.game.contents['지도'].push(item);
          } else if (item.subtitle.split('재활-').length > 1) {
            item.subtitle = item.subtitle.split('재활-')[1];
            temp.game.contents['재활'].push(item);
          }
        });
  
        var trainingList = _.find(lists, {
          type: '훈련'
        });
        _.forEach(trainingList.list[0].videos, function(item) {
          if (item.subtitle.split('지도-').length > 1) {
            item.subtitle = item.subtitle.split('지도-')[1];
            temp.training.videos['지도'].push(item);
          } else if (item.subtitle.split('재활-').length > 1) {
            item.subtitle = item.subtitle.split('재활-')[1];
            temp.training.videos['재활'].push(item);
          }
        });
        _.forEach(trainingList.list[0].contents, function(item) {
          if (item.subtitle.split('지도-').length > 1) {
            item.subtitle = item.subtitle.split('지도-')[1];
            temp.training.contents['지도'].push(item);
          } else if (item.subtitle.split('재활-').length > 1) {
            item.subtitle = item.subtitle.split('재활-')[1];
            temp.training.contents['재활'].push(item);
          }
        });
  
        vm.dashboardContents2 = temp;
      })
      .catch(function(err) {
        toastr.error(err);
      });
  };

  vm.getDashboardContents2();

  // 지도자료 영상, 컨텐츠 등록
  vm.setDashboardContent2 = function (type, type2, type3) {

    // type: game, training
    // type2: video, content
    // type3: 지도, 재활

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type, // game, training
      is_video: type2 === 'video' ? 'Y' : 'N',
      is_admin: vm.setContents2.range === 'all' ? 'Y' : 'N',
      title: vm.dashboardContent2[type][type2][type3].title,
      subtitle: vm.dashboardContent2[type][type2][type3].subtitle && type3 + '-' + vm.dashboardContent2[type][type2][type3].subtitle.name,
      url: vm.dashboardContent2[type][type2][type3].url,
      show_user_type_id: 2
    };

    if (vm.setContents2.range === 'team') {
      if (vm.modalTeam42) {
        data.team_id = vm.modalTeam42.id;
      } else {
        toastr.error('팀을 선택하세요');
        return;
      }
    }

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }

    DashboardService.set(data).then(function (res) {
      toastr.success('등록되었습니다.');
      vm.getDashboardContents2();
    }, function() {
      toastr.error('등록중 오류가 발생하였습니다.');
    }).catch(function(err) {
      toastr.error('등록중 오류가 발생하였습니다.');
    });
  }

  

  // 팀 선택 메뉴 생성
  UserService.getCountries().then(function (res) {
    vm.adminContinents = res.data.list;

    if ($stateParams.continent_id) {
      vm.adminContinent = _.find(vm.adminContinents, {
        id: +$stateParams.continent_id
      });
    } else {
      vm.adminContinent = vm.adminContinents[0];
    }
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  // 대륙 변경
  $scope.$watch('vm.adminContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.adminCountries = res.data.list;
        vm.adminTeams1 = vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;

        if ($stateParams.country_id) {
          vm.adminCountry = _.find(vm.adminCountries, {
            id: +$stateParams.country_id
          });
        } else {
          vm.adminCountry = vm.adminCountries[0];
        }

        $state.transitionTo('Service.admin', {continent_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          reloadOnSearch: false
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 국가 변경
  $scope.$watch('vm.adminCountry', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: newVal.id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.adminTeams1 = res.data.list;

          if ($stateParams.team1_id) {
            vm.adminTeam1 = _.find(vm.adminTeams1, {
              id: +$stateParams.team1_id
            });
          } else {
            vm.adminTeam1 = vm.adminTeams1[0];
          }

          $state.transitionTo('Service.admin', {country_id: newVal.id}, {
            location: true,
            inherit: true,
            relative: $state.$current,
            reloadOnSearch: false
          });

          vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('vm.adminTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.adminTeams2 = res.data.list;

        if ($stateParams.team2_id) {
          vm.adminTeam2 = _.find(vm.adminTeams2, {
            id: +$stateParams.team2_id
          });
        }

        $state.transitionTo('Service.admin', {team1_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
        
        vm.adminTeams3 = vm.adminTeams4 = null;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 2단계 변경
  $scope.$watch('vm.adminTeam2', function (newVal, oldVal) {

    if (newVal) {
      UserService.getTeams({
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        vm.adminTeams3 = res.data.list;

        if ($stateParams.team3_id) {
          vm.adminTeam3 = _.find(vm.adminTeams3, {
            id: +$stateParams.team3_id
          });
        }

        $state.transitionTo('Service.admin', {team2_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });

        vm.adminTeams4 = null;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.adminTeam3', function (newVal, oldVal) {
    if (newVal) {
      UserService.getTeams({
        country_id: vm.adminCountry.id,
        parent_id: newVal.id
      }).then(function (res) {
        // 전체 관리자는 소속팀이 없는 경우 (team_id: 0) 도 조회할 수 있어야 해서 가상의 팀을 만듬
        var noTeam = {
          id: 0,
          can_have_last: false,
          image_url: "/images/teams/default_user.png",
          is_last: true,
          is_last_admin: true,
          name: '무소속'
        };

        vm.adminTeams4 = res.data.list.concat([noTeam]);

        if ($stateParams.team4_id) {
          vm.adminTeam4 = _.find(vm.adminTeams4, {
            id: +$stateParams.team4_id
          });
        }

        $state.transitionTo('Service.admin', {team3_id: newVal.id}, {
          location: true,
          inherit: true,
          relative: $state.$current,
          notify: false
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }
  });

  // 팀 4단계 변경
  $scope.$watch('vm.adminTeam4', function (newVal, oldVal) {
    if (newVal) {
      $state.transitionTo('Service.admin', {team4_id: newVal.id}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      })
    }
  });

  // 팀 선택
  vm.selectTeam = function() {
    if ((vm.appContext.info.team_name === 'National Team' && (vm.appContext.user.user_type_id === '4' || vm.appContext.user.user_type_id === '10' || vm.appContext.user.user_type_id === '12' || vm.appContext.user.user_type_id === '22' ))) {
      if (vm.appContext.info.team_id != vm.adminTeam4.id) {
        toastr.error('자신의 팀만 선택할 수 있습니다.');
        return;
      }
    }

    $state.transitionTo('Service.planner', {type_code:'team', team1_id: vm.adminTeam1.id, team2_id: vm.adminTeam2.id, team3_id: vm.adminTeam3.id, team4_id: vm.adminTeam4.id, team_id: vm.adminTeam4.id, manager_admin_team_id: vm.adminTeam4.id}, {
      location: true,
      inherit: true,
      relative: $state.$current,
      notify: true
    }).then(function() {
      vm.appContext.manager_admin_team = {
        parent_team_name: vm.adminTeam3.name,
        team_id: vm.adminTeam4.id,
        team_name: vm.adminTeam4.name,
        country_id: vm.adminCountry.id,
        country_name: vm.adminCountry.name,
      };
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  };

  // 팀 선택 초기화
  vm.resetTeams = function () {
    vm.adminTeams1 = vm.adminTeams2 = vm.adminTeams3 = vm.adminTeams4 = null;

    vm.appContext.manager_admin_team = null;

    $state.transitionTo('Service.admin', { team1_id: null, team2_id: null, team3_id: null, team4_id: null, manager_admin_team_id: null }, {
      location: true,
      inherit: true,
      relative: $state.$current,
      reloadOnSearch: false
    });
  };

  // 메뉴 조회
  // AdminService.menus({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid
  // }).then(function (res) {
  //   console.log('menus', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  // 역할 조회
  // AdminService.getRoles({
  //   show_21c: 'Y'
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  // 메뉴 할당
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 16,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 17,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 18,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 19,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 20,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 21,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 22,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });
  // AdminService.assignMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   id: 23,
  //   role_id: 1
  // }).then(function (res) {
  //   console.log('roles', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  // 선수 검색
  // AdminService.userList({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   menu_id: 11,
  //   limit: 200,
  //   //page: 2,
  //   //team_id: 26466
  //   //sch_login_id: 'hanmail.net'
  //   sch_name: '김'
  // }).then(function (res) {
  //   console.log('user search', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  
  
  
  /*
  // (1) 전체관리자에게 팀을 할당하기 위해서 user_type_id 를 23 (전체관리자) 에서 10 (단장) 으로 변경 - 팀 할당은 구단주와 단장에게만 가능함
  UserService.modify({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    user_id: vm.appContext.user.user_id,
    user_type_id: 10
  })
    .then(function (res) {

      console.log('success (1)');

      // (2) 전체관리자에게 팀을 할당
      var setTeamData = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        user_id: vm.appContext.user.user_id,
        team_id: $stateParams.manager_admin_team_id
      };

      AdminService.setTeam(setTeamData).then(function(res) {

        console.log('success (2)');
        
        // (3) 전체관리자가 본인 소유 팀목록을 확인 - team_id 체크 - login_id 와 passwd 를 얻음
        var myTeamsData = {
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid
        };
      
        UserService.myTeams(myTeamsData).then(function(res) {

          console.log('success (3)');
          
          var obj = _.find(res.data.list, {
            team_id: $stateParams.manager_admin_team_id
          });

          if (obj) {
            // (4) login_id 와 passwd 를 사용해서 login 을 해서 uuid 를 받음
            UserService.login({
              login_id: obj.login_id,
              passwd: obj.passwd
            }).then(function (res) {

              console.log('success (4)');

              // (5) 발급받은 login_id, uuid 로 경기 생성
              var data = {
                login_id: res.data.login_id,
                uuid: res.data.uuid,
                date: '2018.07.12',
                time: '21:00:00'
              };
          
              PlanService.setGame(data)
                .then(function (res) {
                  $stateParams.game_id = res.data.game_id;
                  $state.go('Service.gameDetail', { game_id: $stateParams.game_id });
                })
                .catch(function (error) {
                  console.log("An error occured : " + error);
                })

            }).catch(function(err) {
              console.log(err);
            });
          }

          // (6) 전체관리자의 user_type_id 를 10 (단장) 에서 23 (전체관리자) 으로 변경
          UserService.modify({
            login_id: vm.appContext.user.login_id,
            uuid: vm.appContext.user.uuid,
            user_id: vm.appContext.user.user_id,
            user_type_id: 23
          })
            .then(function (res) {
              console.log('success (6)');
            })
            .catch(function (error) {
              console.log('ERROR', error);
            });

        }).catch(function(err) {
          console.log(err);
        });

      }).catch(function(err) {
        console.log(err);
      });

    })
    .catch(function (error) {
      console.log('ERROR', error);
    });
  */


  // 디바이스 목록 검색
  // var deviceListData = {
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   menu_id: 21,
  //   team_id: 27181
  //   // 'menu_id' : $scope.activeMenu.id,
  //   // 'parent_id' : vm.selectTeamParentId ? vm.selectTeamParentId : null,
  //   // 'team_id' : vm.selectTeam ? vm.selectTeam.id : null,
  //   // 'team_name' : vm.selectTeam ? vm.selectTeam.text : null,
  //   // page : page,
  //   // 'limit' : 10,
  //   // 'user_name' : vm.schUserName,
  // };
  
  // AdminService.addDevice({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   menu_id: 21,
  //   team_id: 27181,
  //   device_id: 'test_device_id',
  //   device_type: 'A'
  // }).then(function(res){
  //   console.log('device add', res);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  // AdminService.removeDevice({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   menu_id: 21,
  //   //team_id: 27181,
  //   device_id: 'test111111111111'
  // }).then(function(res){
  //   console.log('device remove', res);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  // AdminService.getDeviceList(deviceListData).then(function(res){
  //   console.log('device list', res.data);
  //   vm.adminDeviceList = res.data.list;
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // });

  /*
  AdminService.menus({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    role_id: 4
  }).then(function(res){
    console.log('menus role 4', res.data);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  AdminService.menus({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    role_id: 5
  }).then(function(res){
    console.log('menus role 5', res.data);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  AdminService.menus({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    role_id: 6
  }).then(function(res){
    console.log('menus role 6', res.data);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  AdminService.menus({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    role_id: 7
  }).then(function(res){
    console.log('menus role 7', res.data);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  // 역할 할당
  AdminService.assignRole({
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid,
    user_id: vm.appContext.user.user_id,
    role_id: 4
  }).then(function(res){
    console.log('assign role', res.data);
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });
  */


  // (1) 메뉴 생성
  // (2) 특정 role 에 메뉴를 할당
  // (3) 특정 user 에 해당 role 을 할당
  // AdminService.addMenu({
  //   login_id: vm.appContext.user.login_id,
  //   uuid: vm.appContext.user.uuid,
  //   idx: 10,
  //   name: '새 메뉴',
  //   path: 'newmenu',
  //   url: 'newmenu'
  // }).then(function(res){
  //   console.log('add menu', res.data);
  // }).catch(function (e) {
  //   console.log('ERROR ' + e);
  // }); 


  
  

  var getPlayers = function (team_id, isAdmin, mode) {
    var data = {
      all: 'Y',
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      team_id: team_id
    };

    PlayerService.getPlayers(data)
      .then(function (res) {
        var nonPlayers = _.reject(res.data.non_players, {
          user_id: '' + vm.appContext.user.user_id
        });
        nonPlayers = _.reject(nonPlayers, {
          name: 'SYSTEM_MADE'
        });

        var players = _.reject(res.data.players, {
          user_id: '' + vm.appContext.user.user_id
        });

        vm.members = nonPlayers.concat(players);

        console.log('members', vm.members);
      })
      .catch(function (error) {
        console.log('ERROR ', error)
      });
  }


  vm.members = [];

  if ($stateParams.team4_id) {
    getPlayers($stateParams.team4_id);
  }

  // 팀정보검색
  if ($stateParams.admin_menu === 'team_search') {
    vm.manageTeam = function(mode) {
      if (!vm.adminTeam4 || !vm.adminTeam4.id) {
        return;
      }

      var modeText;
      if (mode === 'A') {
        modeText = '승인';
      } else if (mode === 'D') {
        modeText = '거절';
      } else if (mode === 'O') {
        modeText = '탈퇴';
      } else if (mode === 'R') {
        modeText = '삭제';
      }

      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '상태 변경',
        content: '선택하신 팀을 ' + modeText + '하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '상태 변경',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              AdminService.manageTeam({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 4,
                parent_id: vm.adminTeam3.id,
                country_id: vm.adminCountry.id,
                team_id: vm.adminTeam4.id,
                mode: mode
              }).then(function(res) {
                console.log('manage team', res.data);

                toastr.success('변경되었습니다. 데이터를 다시 불러옵니다.');
        
                vm.resetTeams();
              }).catch(function (error) {
                console.log('ERROR ' + error);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };
  }
  // SGS EPTS 대시보드
  else if ($stateParams.admin_menu === 'iot') {
    vm.eptsTab = 'device';

    // 팀을 선택하여 선수 목록이 변경될 경우 디바이스 다시 조회
    $scope.$watch('vm.adminMainList', function(newVal, oldVal) {
      if (newVal && newVal.length) {
        //var users = _.reject(newVal, {
        //  user_name: 'SYSTEM_MADE'
        //});

        //vm.generateDeviceDonutChartConfig(users, true);
        //vm.generateDeviceBarChartConfig(users);
      } else {
        //vm.adminDeviceDonutChartConfigList = [];
        //vm.adminDeviceDonutChartSmallConfigList = [];
        //vm.adminDeviceBarChartConfigList = [];
      }
    });

    // 디바이스 목록이 변경될 경우
    $scope.$watch('vm.adminDevices.device', function(newVal, oldVal) {
      if (newVal && newVal.length) {
        // 디바이스 목록에 선수 정보를 추가해줌
        _.forEach(newVal, function(item) {
          let user = _.find(vm.adminMainList, {
            user_name: item.name
          });
          if (user) {
            item.user_back_number = user.back_number;
            item.access_dt = user.access_dt;
          }
        });

        vm.generateDeviceDonutChartConfig(newVal, true);
        vm.generateDeviceBarChartConfig(newVal);
      } else {
        vm.adminDeviceDonutChartConfigList = [];
        vm.adminDeviceDonutChartSmallConfigList = [];
        vm.adminDeviceBarChartConfigList = [];
      }
    });

    // 앵커 목록이 변경될 경우
    $scope.$watch('vm.adminDevices.anchor', function(newVal, oldVal) {
      if (newVal && newVal.length) {
        vm.generateDeviceDonutChartConfig(newVal, false, true);
        vm.generateDeviceBarChartConfig(newVal, true);
      } else {
        vm.adminAnchorDonutChartConfigList = [];
        vm.adminAnchorBarChartConfigList = [];
      }
    });

    // 마스터 목록이 변경될 경우
    $scope.$watch('vm.adminDevices.master', function(newVal, oldVal) {
      if (newVal && newVal.length) {
        vm.generateDeviceDonutChartConfig(newVal, false, false, true);
        vm.generateDeviceBarChartConfig(newVal, false, true);
      } else {
        vm.adminMasterDonutChartConfigList = [];
        vm.adminMasterBarChartConfigList = [];
      }
    });

    if ($stateParams.team4_id) {
      AdminService.getStatus({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 19,
        team_id: $stateParams.team4_id
      }).then(function(res) {
        console.log('status', res.data);
        vm.adminStatus = res.data;
      }).catch(function (error) {
        console.log('ERROR ' + error);
      });

      AdminService.getMain({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 19,
        team_id: $stateParams.team4_id
      }).then(function(res) {
        console.log('main', res.data.list);
        let arr = res.data.list;

        // system 이 생성한 사용자 제외
        arr = _.reject(arr, {
          user_name: 'SYSTEM_MADE'
        });

        // 선수만 선택
        vm.adminMainList = _.filter(arr, {
          role_id: 6
        });

        _.forEach(vm.adminMainList, function(item) {
          // AdminService.userList({
          //   login_id: vm.appContext.user.login_id,
          //   uuid: vm.appContext.user.uuid,
          //   sch_login_id: item.login_id,
          //   menu_id: 22,  // 사용자 관리 메뉴
          //   limit: 200
          // }).then(function (res) {
          //   item.name = res.data.list[0].name;
          //   item.back_number = res.data.list[0].back_number;
          // }).catch(function (e) {
          //   console.log('ERROR ' + e);
          // });
        });

      }).catch(function (error) {
        console.log('ERROR ' + error);
      });
    }

    vm.adminDeviceDonutChartConfigList = [];
    vm.adminDeviceDonutChartSmallConfigList = [];
    vm.adminDeviceBarChartConfigList = [];
    vm.adminAnchorDonutChartConfigList = [];
    vm.adminAnchorBarChartConfigList = [];
    vm.adminMasterDonutChartConfigList = [];
    vm.adminMasterBarChartConfigList = [];

    vm.adminDeviceDonutChartConfig = {
      chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          backgroundColor: 'transparent'
      },
      credits: {
        enabled: false
      },
      title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          y: -3,
          useHTML: true,
          style: {
              fontSize: '20px',
              textAlign: 'center'
          }
      },
      tooltip: {
          enabled: false
      },
      colors: ["#E6645C","#55A9DC","#886DB3","#6CC080"],
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              size: '95%',
              dataLabels: {
                  enabled: true,
                  distance: -30,
                  style: {
                      fontWeight: 'bold',
                      color: 'white'
                  },
                  formatter: function() {
                    if (this.point.index === 0) { // 첫 번째 데이터만 표시
                      return this.y;
                    } else {
                      return null;
                    }
                  },
                  style: {
                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
              }
          }
      },
      series: [{
          name: 'Brands',
          innerSize: '50%',
          colorByPoint: true,
          data: []
      }]
    };
    vm.adminDeviceDonutChartSmallConfig = {
      chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          backgroundColor: 'transparent'
      },
      credits: {
        enabled: false
      },
      title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          y: -3,
          useHTML: true,
          style: {
              fontSize: '20px',
              textAlign: 'center'
          }
      },
      tooltip: {
          enabled: false
      },
      colors: ["#E6645C","#55A9DC","#886DB3","#6CC080"],
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              size: '95%',
              dataLabels: {
                  enabled: true,
                  distance: -30,
                  style: {
                      fontWeight: 'bold',
                      color: 'white'
                  },
                  formatter: function() {
                    if (this.point.index === 0) { // 첫 번째 데이터만 표시
                      return this.y;
                    } else {
                      return null;
                    }
                  },
                  style: {
                      color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                  }
              }
          }
      },
      series: [{
          name: 'Brands',
          innerSize: '50%',
          colorByPoint: true,
          data: []
      }]
    };
    vm.adminDeviceBarChartConfig = {
      chart: {
          type: 'bar',
          height: 30,
          margin: [0, 0, 0, 0],
          spacing: [0, 0, 0, 0],
          backgroundColor: 'transparent',
          events: {
            click: function() {
              // 디바이스인 경우
              if (vm.eptsTab === 'device') {
                var chart = this;

                var containerId = $('#' + chart.container.id).closest('.device-chart-container').find('.donut-chart').eq(0).find('.highcharts-container ').attr('id');
                var title = $('#' + chart.container.id).closest('.w3-col').prev('.w3-col').find('h4.w3-left').html();
                drawDonutChart(containerId, title, true, [chart.series[1].processedYData[0] - 10, chart.series[0].processedYData[0] + 10]);

                var containerId = $('#' + chart.container.id).closest('.device-chart-container').find('.donut-chart').eq(1).find('.highcharts-container ').attr('id');
                var title = $('#' + chart.container.id).closest('.w3-col').prev('.w3-col').find('h4.w3-left').html();
                drawDonutChart(containerId, title, true, [chart.series[1].processedYData[0] + 10, chart.series[0].processedYData[0] - 10]);
              }
            }
          }
      },
      credits: {
              enabled: false
      },
      title: {
          text: ''
      },
      colors: ['#ced4da', '#E91E63'],
      xAxis: {
          categories: [''],
          labels: {
                  enabled: false
          },
          lineWidth: 0,
          tickLength: 0
      },
      yAxis: {
          min: 0,
          title: {
              enabled: false
          },
          labels: {
                  enabled: false
          },
          gridLineWidth: 0
      },
      legend: {
          enabled: false
      },
      tooltip: {
              enabled: false
      },
      plotOptions: {
          series: {
              stacking: 'percent',
              events: {
                click: function() {
                  // 디바이스인 경우
                  if (vm.eptsTab === 'device') {
                    var chart = this.chart;

                    var containerId = $('#' + chart.container.id).closest('.device-chart-container').find('.donut-chart').eq(0).find('.highcharts-container ').attr('id');
                    var title = $('#' + chart.container.id).closest('.w3-col').prev('.w3-col').find('h4.w3-left').html();
                    drawDonutChart(containerId, title, true, [chart.series[1].processedYData[0] - 10, chart.series[0].processedYData[0] + 10]);

                    var containerId = $('#' + chart.container.id).closest('.device-chart-container').find('.donut-chart').eq(1).find('.highcharts-container ').attr('id');
                    var title = $('#' + chart.container.id).closest('.w3-col').prev('.w3-col').find('h4.w3-left').html();
                    drawDonutChart(containerId, title, true, [chart.series[1].processedYData[0] + 10, chart.series[0].processedYData[0] - 10]);
                  }
                }
              }
          }
      },
      series: [{
          data: []
      }, {
          data: []
      }]
    };

    vm.generateDeviceDonutChartConfig = function(list, small, anchor, master) {
      var arr = [];

      _.forEach(list, function(item, i) {
        var value = parseInt(Math.random() * 100, 10),
          seriesData = [{
            y: value
          }, {
            y: 100 - value
          }];

        if (small) {
          var options = angular.copy(vm.adminDeviceDonutChartSmallConfig);
          options.title.text = item.user_back_number;
          options.title.y = 6;
        } else if (anchor) {
          var options = angular.copy(vm.adminDeviceDonutChartConfig);
          options.title.text = 'Anchor' + (i + 1);
          options.title.y = 6;
        } else if (master) {
          var options = angular.copy(vm.adminDeviceDonutChartConfig);
          options.title.text = 'Master' + (i + 1);
        } else {
          var options = angular.copy(vm.adminDeviceDonutChartConfig);
          options.title.text = item.user_name + '<br>' + item.user_back_number;
        }
        options.series[0].data = seriesData;

        arr.push(options);
      });

      if (small) {
        // 디바이스인 경우 L, R 양쪽이라서 한번더 생성
        _.forEach(list, function(item, i) {
          var value = parseInt(Math.random() * 100, 10),
            seriesData = [{
              y: value
            }, {
              y: 100 - value
            }];
  
          if (small) {
            var options = angular.copy(vm.adminDeviceDonutChartSmallConfig);
            options.title.text = item.user_back_number;
            options.title.y = 6;
          } else if (anchor) {
            var options = angular.copy(vm.adminDeviceDonutChartConfig);
            options.title.text = 'Anchor' + (i + 1);
            options.title.y = 6;
          } else if (master) {
            var options = angular.copy(vm.adminDeviceDonutChartConfig);
            options.title.text = 'Master' + (i + 1);
          } else {
            var options = angular.copy(vm.adminDeviceDonutChartConfig);
            options.title.text = item.user_name + '<br>' + item.user_back_number;
          }
          options.series[0].data = seriesData;
  
          arr.push(options);
        });

        vm.adminDeviceDonutChartSmallConfigList = arr;
      } else if (anchor) {
        vm.adminAnchorDonutChartConfigList = arr;
      } else if (master) {
        vm.adminMasterDonutChartConfigList = arr;
      } else {
        vm.adminDeviceDonutChartConfigList = arr;
      }
    };

    vm.generateDeviceBarChartConfig = function(list, anchor, master) {
      var arr = [];

      _.forEach(list, function(item, i) {
        var arr2 = [],
          max = 9;
        if (anchor) {
          max = 22;
        } else if (master) {
          max = 6;
        }

        for (var j = 0; j < max; j++) {
          var options = angular.copy(vm.adminDeviceBarChartConfig);
          options.series[0].data = [parseInt(Math.random() * 100, 10)];
          options.series[1].data = [100 - options.series[0].data[0]];

          if (anchor && j > 17) {
            options.colors = ['#ced4da', 'green'];
          }

          arr2.push(options);
        }
        arr.push(arr2);
      });

      if (anchor) {
        vm.adminAnchorBarChartConfigList = arr;
      } else if (master) {
        vm.adminMasterBarChartConfigList = arr;
      } else {
        vm.adminDeviceBarChartConfigList = arr;
      }
    };

    function drawDonutChart(container, name, titlePosition, data, small) {
      var value = parseInt(Math.random() * 100, 10),
        seriesData = [{
          y: value
        }, {
          y: 100 - value
        }];

      if (data) {
        seriesData[0].y = data[0];
        seriesData[1].y = data[1];
      }

      if (small) {
        var options = angular.copy(vm.adminDeviceDonutChartSmallConfig);
      } else {
        var options = angular.copy(vm.adminDeviceDonutChartConfig);
      }
      options.title.text = name;
      if (titlePosition) {
        options.title.y = 6;
      }
      options.series[0].data = seriesData;

      Highcharts.chart(container, options);
    }

    

    function drawBarChart(container, color) {
      var options = angular.copy(vm.adminDeviceBarChartConfig);
      options.series[0].data = [parseInt(Math.random() * 100, 10)];
      options.series[1].data = [100 - options.series[0].data[0]];

      if (color) {
        options.colors = ['#ced4da', 'green'];
      }

      Highcharts.chart(container, options);
    }

    $scope.$watch('vm.eptsTab', function(newVal, oldVal) {
      if (newVal === 'master') {
        $timeout(function() {
          drawDonutChart('admin-master-donut-chart1', 'EPTS', true);
          drawDonutChart('admin-master-donut-chart2', 'VAR', true);
          drawDonutChart('admin-master-donut-chart3', 'GLT', true);
          drawDonutChart('admin-master-donut-chart4', 'FIELD', true);
          drawDonutChart('admin-master-donut-chart5', 'BALL', true);
          drawDonutChart('admin-master-donut-chart6', 'ECO', true);
  
          drawBarChart('admin-master-bar-chart1-1');
          drawBarChart('admin-master-bar-chart1-2');
          drawBarChart('admin-master-bar-chart1-3');
          drawBarChart('admin-master-bar-chart1-4');
          drawBarChart('admin-master-bar-chart1-5');
          drawBarChart('admin-master-bar-chart1-6');
          drawBarChart('admin-master-bar-chart2-1');
          drawBarChart('admin-master-bar-chart2-2');
          drawBarChart('admin-master-bar-chart2-3');
          drawBarChart('admin-master-bar-chart2-4');
          drawBarChart('admin-master-bar-chart2-5');
          drawBarChart('admin-master-bar-chart2-6');
          drawBarChart('admin-master-bar-chart3-1');
          drawBarChart('admin-master-bar-chart3-2');
          drawBarChart('admin-master-bar-chart3-3');
          drawBarChart('admin-master-bar-chart3-4');
          drawBarChart('admin-master-bar-chart3-5');
          drawBarChart('admin-master-bar-chart3-6');
          drawBarChart('admin-master-bar-chart4-1');
          drawBarChart('admin-master-bar-chart4-2');
          drawBarChart('admin-master-bar-chart4-3');
          drawBarChart('admin-master-bar-chart4-4');
          drawBarChart('admin-master-bar-chart4-5');
          drawBarChart('admin-master-bar-chart4-6');
          drawBarChart('admin-master-bar-chart5-1');
          drawBarChart('admin-master-bar-chart5-2');
          drawBarChart('admin-master-bar-chart5-3');
          drawBarChart('admin-master-bar-chart5-4');
          drawBarChart('admin-master-bar-chart5-5');
          drawBarChart('admin-master-bar-chart5-6');
          drawBarChart('admin-master-bar-chart6-1');
          drawBarChart('admin-master-bar-chart6-2');
          drawBarChart('admin-master-bar-chart6-3');
          drawBarChart('admin-master-bar-chart6-4');
          drawBarChart('admin-master-bar-chart6-5');
          drawBarChart('admin-master-bar-chart6-6');
        });
      }
    });

    // 추가
    vm.adminAddDevice = function() {
      vm.adminAddDeviceId = '';

      if (!$stateParams.team4_id) {
        toastr.error('팀을 선택해주십시오');
        return;
      }
      if (vm.eptsTab === 'device' && !vm.adminSelectedPlayer) {
        toastr.error('선수를 선택해주십시오');
        return;
      }

      let type;
      let typeName;

      switch (vm.eptsTab) {
        case 'device':
          type = 'G';
          typeName = 'SMART GUARD 디바이스';
          break;

        case 'anchor':
          type = 'A';
          typeName = 'IoT 디바이스';
          break;

        case 'master':
          type = 'M';
          typeName = '마스터 시스템';
          break;
      }

      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '디바이스 추가',
        content: '<input type="text" style="width:200px;" ng-model="vm.adminAddDeviceId" placeholder="디바이스 ID를 입력하세요"><br><br>' + typeName + '를 추가하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '추가',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              if (!vm.adminAddDeviceId) {
                toastr.error('디바이스 ID를 입력하세요');
                return;
              }

              let params = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 21,
                team_id: $stateParams.team4_id,
                device_id: vm.adminAddDeviceId,
                device_type: type
              };

              if (vm.eptsTab === 'device') {
                params.user_id = vm.adminSelectedPlayer.user_id;
              }

              AdminService.addDevice(params).then(function(res){
                console.log('device add', res);
                toastr.success(typeName + '가 추가되었습니다.');
                vm.adminGetDeviceList();
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    vm.showDeleteBtn = {
      'anchor': false,
      'master': false
    };

    // 삭제
    vm.adminRemoveDevice = function(deviceId) {
      if (!$stateParams.team4_id) {
        toastr.error('팀을 선택해주십시오');
        return;
      }
      if (vm.eptsTab === 'device' && !vm.adminSelectedPlayer) {
        toastr.error('선수를 선택해주십시오');
        return;
      }

      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '디바이스 삭제',
        content: '삭제하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '삭제',
            btnClass: 'btn-blue',
            action: function (scope, button) {

              let params = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 21,
                team_id: $stateParams.team4_id,
                device_id: deviceId
              };

              if (vm.eptsTab === 'device') {
                params.user_id = vm.adminSelectedPlayer.user_id;
              }
  
              AdminService.removeDevice(params).then(function(res){
                console.log('device remove', res);
                toastr.success('삭제되었습니다.');
                vm.adminGetDeviceList();
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });     
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    // 디바이스 사용자 변경
    vm.adminUserChangeDevice = function() {
      vm.adminAddDeviceIntId = '';

      if (vm.eptsTab === 'device' && !vm.adminSelectedPlayer) {
        toastr.error('선수를 선택해주십시오');
        return;
      }

      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '디바이스 사용자 변경',
        content: '<input type="text" style="width:200px;" ng-model="vm.adminAddDeviceId" placeholder="디바이스 ID를 입력하세요"><br><br>' + typeName + '를 추가하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '추가',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              if (!vm.adminAddDeviceIntId) {
                toastr.error('디바이스 ID를 입력하세요');
                return;
              }

              let params = {
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 21,
                device_int_id: vm.adminAddDeviceIntId
              };

              if (vm.eptsTab === 'device') {
                params.user_id = vm.adminSelectedPlayer.user_id;
              }

              AdminService.setDevice(params).then(function(res){
                console.log('device set', res);
                toastr.success('디바이스 사용자가 변경되었습니다.');
                vm.adminGetDeviceList();
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    // 디바이스 목록 불러오기
    vm.adminGetDeviceList = function() {
      AdminService.getDeviceList({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 21,
        team_id: $stateParams.team4_id
      }).then(function(res){
        console.log('device list', res.data);
        vm.adminDevices = {
          device: _.filter(res.data.list, {
            type: '정강이보호대'
          }),
          anchor: _.filter(res.data.list, {
            type: '앵커'
          }),
          master: _.filter(res.data.list, {
            type: 'Master System'
          })
        };
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    };

    $timeout(function() {   // vm.adminMainList 를 먼저 조회하도록 1초 뒤에 실행
      vm.adminGetDeviceList();
    }, 1000);

    // 펌웨어 목록
    vm.adminFirmwareList = function() {
      AdminService.getFirmwareList({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 19,
        device_type: 'G'
      }).then(function(res) {
        console.log('firmware list', res.data);

        vm.firmwareList = res.data.list;
      }).catch(function (error) {
        console.log('ERROR ' + error);
      });
    };

    vm.adminFirmwareList();

    // 펌웨어 파일 업로드시 필요한 데이터
    var firmwareFormData = [
      {
        name: 'login_id',
        value: vm.appContext.user.login_id
      },
      {
        name: 'uuid',
        value: vm.appContext.user.uuid
      },
      {
        name: 'menu_id',
        value: 19
      },
      {
        name: 'device_type',
        value: 'G'
      },
      {
        name: 'firmware_type',
        value: 'A'
      },
      {
        name: 'version_code',
        value: ''
      },
      {
        name: 'version_string',
        value: ''
      }
    ];

    $scope.$watch('vm.adminFirmwareVersionCode', function(newVal, oldVal) {
      var versionCode = _.find(firmwareFormData, {
          name: 'version_code'
        });

      versionCode.value = newVal;
    });

    $scope.$watch('vm.adminFirmwareVersionString', function(newVal, oldVal) {
      var versionString = _.find(firmwareFormData, {
          name: 'version_string'
        });

      versionString.value = newVal;
    });
    
    // 펌웨어 파일을 서버에 업로드
    $timeout(function() {
      var fileUploadOptions = {
        forceIframeTransport: (vm.appContext.isMobileApp ? false : true),
        url: AppSettings.apiUrl.restRoot + 'admin/add_firmware',
        //dataType: 'json',
        fileInput: $('#upload_firmware'),
        formData: firmwareFormData,
        submit: function(e, data) {
          console.log('firmware submit', e, data);
        },
        done: function (e, data) {
          var result;
          console.log('data', data);

          // 페이지 새로고침
          $state.go($state.current, $stateParams, { reload: true });
        }
      };
      if (!vm.appContext.isMobileApp) {
        fileUploadOptions.redirect = location.origin + '/#!/result';
      }
    
      $('#upload_firmware').fileupload(fileUploadOptions);
    }, 3000);

    // 펌웨어 삭제
    vm.adminRemoveFirmware = function(id) {
      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '펌웨어 삭제',
        content: '선택하신 펌웨어를 삭제하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '삭제',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              AdminService.removeFirmware({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                firmware_id: id,
                menu_id: 19
              }).then(function(res) {
                toastr.success('삭제되었습니다.');
                console.log('remove firmware', res.data);
        
                vm.adminFirmwareList();
              }).catch(function (error) {
                console.log('ERROR ' + error);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };
  }
  // SGS EPTS 관리
  else if ($stateParams.admin_menu === 'guards') {
    // // 펌웨어 목록
    // vm.adminFirmwareList = function() {
    //   AdminService.getFirmwareList({
    //     login_id: vm.appContext.user.login_id,
    //     uuid: vm.appContext.user.uuid,
    //     menu_id: 4,
    //     device_type: 'G'
    //   }).then(function(res) {
    //     console.log('firmware list', res.data);

    //     vm.firmwareList = res.data.list;
    //   }).catch(function (error) {
    //     console.log('ERROR ' + error);
    //   });
    // };

    // vm.adminFirmwareList();

    // // 펌웨어 파일 업로드시 필요한 데이터
    // var firmwareFormData = [
    //   {
    //     name: 'login_id',
    //     value: vm.appContext.user.login_id
    //   },
    //   {
    //     name: 'uuid',
    //     value: vm.appContext.user.uuid
    //   },
    //   {
    //     name: 'menu_id',
    //     value: 4
    //   },
    //   {
    //     name: 'device_type',
    //     value: 'G'
    //   },
    //   {
    //     name: 'firmware_type',
    //     value: 'A'
    //   },
    //   {
    //     name: 'version_code',
    //     value: ''
    //   },
    //   {
    //     name: 'version_string',
    //     value: ''
    //   }
    // ];

    // $scope.$watch('vm.adminFirmwareVersionCode', function(newVal, oldVal) {
    //   var versionCode = _.find(firmwareFormData, {
    //       name: 'version_code'
    //     });

    //   versionCode.value = newVal;
    // });

    // $scope.$watch('vm.adminFirmwareVersionString', function(newVal, oldVal) {
    //   var versionString = _.find(firmwareFormData, {
    //       name: 'version_string'
    //     });

    //   versionString.value = newVal;
    // });
    
    // // 펌웨어 파일을 서버에 업로드
    // var fileUploadOptions = {
    //   forceIframeTransport: (vm.appContext.isMobileApp ? false : true),
    //   url: AppSettings.apiUrl.restRoot + 'admin/add_firmware',
    //   //dataType: 'json',
    //   fileInput: $('#upload_firmware'),
    //   formData: firmwareFormData,
    //   submit: function(e, data) {
    //     console.log('firmware submit', e, data);
    //   },
    //   done: function (e, data) {
    //     var result;
    //     console.log('data', data);

    //     // 페이지 새로고침
    //     $state.go($state.current, $stateParams, { reload: true });
    //   }
    // };
    // if (!vm.appContext.isMobileApp) {
    //   fileUploadOptions.redirect = location.origin + '/#!/result';
    // }
    // $('#upload_firmware').fileupload(fileUploadOptions);

    // // 펌웨어 삭제
    // vm.adminRemoveFirmware = function(id) {
    //   $ngConfirm({
    //     boxWidth: '30%',
    //     useBootstrap: false,
    //     title: '펌웨어 삭제',
    //     content: '선택하신 펌웨어를 삭제하시겠습니까?',
    //     scope: $scope,
    //     buttons: {
    //       confirm: {
    //         text: '삭제',
    //         btnClass: 'btn-blue',
    //         action: function (scope, button) {
  
    //           AdminService.removeFirmware({
    //             login_id: vm.appContext.user.login_id,
    //             uuid: vm.appContext.user.uuid,
    //             firmware_id: id,
    //             menu_id: 4
    //           }).then(function(res) {
    //             toastr.success('삭제되었습니다.');
    //             console.log('remove firmware', res.data);
        
    //             vm.adminFirmwareList();
    //           }).catch(function (error) {
    //             console.log('ERROR ' + error);
    //           });
  
    //         }
    //       },
    //       cancel: {
    //         text: '취소',
    //         btnClass: 'btn-orange',
    //       },
    //     }
    //   });
    // };
  }
  // 신분권한관리
  else if ($stateParams.admin_menu === 'roles') {
    /*
    사용자(users), 메뉴(menus: 혹은 권한), 역할(roles: 혹은 신분) 3가지 항목이 있음
​
    아래의 2가지 단계를 통해 특정 user에게 특정 menu를 볼 권한을 할당함
    ​
    (1) 특정 role에 menu를 할당 (admin/assign_menu)
    ​
    (2) 특정 user에 해당 role을 할당 (admin/assign_role)
    ​
    ​
    - 위 2가지 단계는 admin/revoke_menu나 admin/revoke_role을 통해 취소할 수 있음
    ​
    - admin/users를 보면 어떤 user에게 어떤 role이 할당되어 있는지 알 수 있음
    ​
    - 어떤 role에 어떤 menu가 할당되어 있는지를 보기 위해서는 admin/menus?role_id=  을 이용하시면 됨
    ​
    - menu는 관리자 페이지가 추가될 때마다 admin/add_menu를 이용하여 추가하게됨
    ​
    - 모든 관리자 API에는 menu_id가 parameter로 들어가게 됨
    ​
      로그인 사용자가 해당 menu_id에 대한 role을 할당받지 못했다면 그 API는 NO_PRIV(해당 메뉴에 대한 권한이 없음) 오류가 발생함
    */
  
    // (1) 특정 role 에 menu 를 할당
    // AdminService.assignMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   id: 14,
    //   role_id: 1
    // }).then(function (res) {
    //   console.log('roles', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    // (2) 특정 user 에 해당 role 을 할당
    // AdminService.assignRole({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   user_id: 910,
    //   role_id: 102
    // }).then(function(res){
    //   console.log('assign role', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    // (3) 특정 user 에 해당 role 을 할당 취소
    // AdminService.revokeRole({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   user_id: vm.appContext.user.user_id,
    //   role_id: 1
    // }).then(function(res){
    //   console.log('assign role', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    // 관리자에서 API 를 호출할 때 menu_id 를 parameter 로 보내야 하는데 그때 로그인한 사용자가 할당받은 menu_id 이어야 함

    // AdminService.menus({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid
    // }).then(function (res) {
    //   console.log('menus', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    if ($stateParams.team4_id) {
      getPlayers($stateParams.team4_id);
    }

    $scope.$watch('vm.adminRoleSearchText', function(newVal, oldVal) {
      if (newVal) {
        $('#role-table').find('tbody').find('tr').each(function() {
          var tr = $(this),
            td = tr.find('td').eq(0);

          if (td.html().toUpperCase().indexOf(newVal.toUpperCase()) > -1) {
            tr[0].style.display = '';
          } else {
            tr[0].style.display = 'none';
          }
        });
      } else {
        $('#role-table').find('tbody').find('tr').each(function() {
          $(this)[0].style.display = '';
        });
      }
    });

    vm.adminUsers = {};
    vm.adminAllUsers = [];

    // 사용자 정보 조회
    AdminService.getUsers({
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      show_21c: 'Y'
    }).then(function(res){
      console.log('21c users', res.data);

      _.forEach(res.data.users, function(user) {
        if (vm.adminUsers[user.role_id]) {
          vm.adminUsers[user.role_id].push(user);
        } else {
          vm.adminUsers[user.role_id] = [user];
        }
      });

      AdminService.getUsers({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid
      }).then(function(res){
        console.log('users', res.data);

        _.forEach(res.data.users, function(user) {
          if (vm.adminUsers[user.role_id]) {
            vm.adminUsers[user.role_id].push(user);
          } else {
            vm.adminUsers[user.role_id] = [user];
          }
        });

        _.forEach(vm.adminUsers, function(item) {
          _.forEach(item, function(item2) {
            vm.adminAllUsers.push(item2);
          });
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    vm.adminMenus = {};

    // 모든 메뉴 조회
    AdminService.menus({
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid
    }).then(function (res) {
      vm.adminAllMenus = _.sortBy(res.data.menus, function(item) {
        return +item.idx;
      });

      // 역할 조회
      AdminService.getRoles({
        show_21c: 'Y'
      }).then(function (res) {
        console.log('21c roles', res.data);
        let adminRoles = res.data.roles;
        vm.adminAdminRoles = res.data.roles;

        AdminService.getRoles().then(function (res2) {
          console.log('roles', res2.data);

          vm.adminRoles = adminRoles.concat(res2.data.roles);

          _.forEach(vm.adminRoles, function(item, i) {
            (function(item, i) {
              // 로딩 속도 개선을 위해 순차적 호출
              $timeout(function() {
                // 역할에 할당된 메뉴 조회
                AdminService.menus({
                  login_id: vm.appContext.user.login_id,
                  uuid: vm.appContext.user.uuid,
                  role_id: item.id
                }).then(function (res3) {
                  //console.log(item.name + ' role id ' + item.id + ' menus', res.data);
      
                  item.menus = res3.data.menus;
      
                  vm.adminMenus[item.id] = {};
                  _.forEach(item.menus, function(menu) {
                    vm.adminMenus[item.id][menu.id] = menu.is_active;
                  });
                }).catch(function (e) {
                  console.log('ERROR ' + e);
                });
              }, i * 1000);
            })(item, i);
          });
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    // 사용자 역할 할당
    vm.adminAssignRole = function($event, userId) {
      var roleId = $($event.target).prev('select').val();
      
      if (!roleId) {
        toastr.error('역할을 선택해주십시오');
        return;
      }

      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '사용자 역할 할당',
        content: '선택하신 사용자에게 이 역할을 할당하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '할당',
            btnClass: 'btn-blue',
            action: function (scope, button) {

              AdminService.assignRole({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                user_id: userId,
                role_id: roleId
              }).then(function(res){
                $state.go($state.current, $stateParams, {reload: true});
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    // 사용자 거절
    vm.adminManageUser = function(mode, userId) {
      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '사용자 거절',
        content: '선택하신 사용자를 거절하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '거절',
            btnClass: 'btn-red',
            action: function (scope, button) {

              AdminService.manageUser({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 22,  // 사용자 관리 메뉴
                user_id: userId,
                mode: mode
              }).then(function(res){
                $state.go($state.current, $stateParams, {reload: true});
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    // 사용자 역할 삭제
    vm.adminRevokeRole = function(userId, roleId) {
      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '사용자 역할 삭제',
        content: '선택하신 사용자에게서 이 역할을 삭제하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '삭제',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              AdminService.revokeRole({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                user_id: userId,
                role_id: roleId
              }).then(function(res){
                $state.go($state.current, $stateParams, {reload: true});
              }).catch(function (e) {
                console.log('ERROR ' + e);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };

    // 메뉴 할당/할당해제
    vm.assignRevokeMenu = function($event, roleId, menuId) {
      if ($event.target.checked) {
        AdminService.assignMenu({
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          id: menuId,
          role_id: roleId
        }).then(function (res) {
          toastr.success('메뉴가 할당 되었습니다.');
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
      } else {
        AdminService.revokeMenu({
          login_id: vm.appContext.user.login_id,
          uuid: vm.appContext.user.uuid,
          id: menuId,
          role_id: roleId
        }).then(function(res){
          toastr.success('메뉴가 할당해제 되었습니다.');
          //$state.go($state.current, $stateParams, {reload: true});
        }).catch(function (e) {
          console.log('ERROR ' + e);
        });
      }
    };

    vm.adminUserCheck = function(user) {
      var obj = _.find(vm.adminAllUsers, {
        user_id: user.user_id
      });

      if (obj) {
        return true;
      } else {
        return false;
      }
    };

    // 사용자 검색
    vm.adminUserSearchOption = 'sch_login_id';

    vm.adminUserSearch = function() {
      if (!vm.adminUserSearchValue) {
        toastr.error('검색어를 입력하십시오');
        return;
      }

      var searchOptions = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 22,  // 사용자 관리 메뉴
        limit: 200
      };
      searchOptions[vm.adminUserSearchOption] = vm.adminUserSearchValue;

      AdminService.userList(searchOptions).then(function (res) {
        console.log('user search', res.data);

        vm.members = res.data.list;
        _.forEach(vm.members, function(item) {
          // UserService.info({
          //   'user_id': item.id
          // }).then(function (res) {
          //   if (res && res.data) {
          //     item.parent_user_type_id = res.data.parent_user_type_id;
          //   }
          // }).catch(function(err) {
          //   console.log(err);
          // });
        });
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    };

    vm.changeUserTypeId = null;

    // 사용자 구분
    UserService.getUserTypes().then(function (res) {
      vm.userTypes1 = res.data.list;
    });

    // 사용자 구분 1단계 변경
    $scope.$watch('vm.selectedUserType1', function (newVal, oldVal) {
      if (newVal && !newVal.is_last) {
        UserService.getUserTypes({ parent_id: newVal.id }).then(function (res) {
          vm.userTypes2 = res.data.list;
          vm.selectedUserType2 = vm.userTypes2[0];
        });
      } else {
        if (newVal) {
          vm.changeUserTypeId = newVal.id;
        }

        vm.userTypes2 = null;
      }
    });

    // 사용자 구분 2단계 변경
    $scope.$watch('vm.selectedUserType2', function (newVal, oldVal) {
      if (newVal) {
        vm.changeUserTypeId = newVal.id;
      }
    });

    // 사용자 구분 변경
    vm.changeUserType = function(loginId, userId) {
      if (!loginId || !userId) {
        toastr.error('사용자 선택중 에러가 발생하였습니다.');
        return;
      }
      if (!vm.changeUserTypeId) {
        toastr.error('변경하려는 회원 구분을 선택하십시오');
        return;
      }
      
      UserService.modify({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        user_id: userId,
        user_type_id: vm.changeUserTypeId
      })
        .then(function (res) {
          if (res.data.result === 'SUC') {
            toastr.success('변경되었습니다.');
            $state.go($state.current, $stateParams, { reload: true });
          } else {
            let message;
            switch (res.data.result) {
              case 'DUP':
                message = '사용 중인 아이디입니다.';
                break;
              case 'EXP':
                message = '관리자 세션 정보가 불일치합니다.'
                break;
              case 'TEAM_NO_MATCH':
                message = '관리자 팀과 개인 팀이 불일치합니다.'
                break;
              case 'REJECTED':
                message = '승인 거절된 팀/협회/회사/일반 입니다.';
                break;
              case 'NO_CODE_INPUT':
                message = '이메일 인증코드 입력값이 없습니다.'
                break;
              case 'NO_CODE':
                message = '인증메일 발송을 해주십시오';
                break;
              case 'CODE_MISMATCH':
                message = '이메일 인증코드를 받은 이메일 주소와 가입하시려는 이메일 주소가 다릅니다.';
                break;
              case 'DUP_BACK_NUMBER':
                message = '같은 배번의 선수가 등록되어 있습니다. 다른 배번을 선택해주십시오';
                break;
              case 'DUP_USER_TYPE':
                message = '같은 회원 구분이 이미 팀에 등록되어 있어서 수정하실 수 없습니다.';
                break;
              default:
                message = '회원가입 중 오류가 발생하였습니다.';
                break;
            }
            toastr.error(message);
          }
        })
        .catch(function (error) {
          console.log('ERROR', error);
        });
    };

    // 전체 메뉴 조회
    // AdminService.menus({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid
    // }).then(function (res) {
    //   vm.adminAllMenus = res.data.menus;
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    // 메뉴 삭제
    // AdminService.removeMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   id: 14
    // }).then(function (res) {
    //   console.log(res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });




    // 메뉴 추가
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 1,
    //   name: '팀정보검색',
    //   path: '/service/admin?admin_menu=team_search',
    //   url: '/service/admin?admin_menu=team_search'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 2,
    //   name: '대시보드컨텐츠',
    //   path: '/service/admin?admin_menu=dashboard_contents',
    //   url: '/service/admin?admin_menu=dashboard_contents'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 3,
    //   name: '지도자료컨텐츠',
    //   path: '/service/admin?admin_menu=contents',
    //   url: '/service/admin?admin_menu=contents'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 4,
    //   name: 'SGS EPTS 대시보드',
    //   path: '/service/admin?admin_menu=iot',
    //   url: '/service/admin?admin_menu=iot'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 5,
    //   name: 'SGS EPTS 관리',
    //   path: '/service/admin?admin_menu=guards',
    //   url: '/service/admin?admin_menu=guards'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 6,
    //   name: '신분권한관리',
    //   path: '/service/admin?admin_menu=roles',
    //   url: '/service/admin?admin_menu=roles'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 7,
    //   name: '사용자 관리',
    //   path: '/service/admin?admin_menu=users',
    //   url: '/service/admin?admin_menu=users'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 8,
    //   name: '데이터 관리',
    //   path: '/service/admin?admin_menu=data',
    //   url: '/service/admin?admin_menu=data'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 9,
    //   name: '일정관리 조회',
    //   path: '/service/planner',
    //   url: '/service/planner'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 10,
    //   name: '일정관리 등록/수정/삭제',
    //   path: '/service/planner',
    //   url: '/service/planner'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 11,
    //   name: '건강관리 조회',
    //   path: '/service/health',
    //   url: '/service/health'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 12,
    //   name: '건강관리 등록/수정/삭제',
    //   path: '/service/health',
    //   url: '/service/health'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 13,
    //   name: '부상관리 조회',
    //   path: '/service/injury',
    //   url: '/service/injury'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 14,
    //   name: '부상관리 등록/수정/삭제',
    //   path: '/service/injury',
    //   url: '/service/injury'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 15,
    //   name: '훈련관리 조회',
    //   path: '/service/event?type_code=training',
    //   url: '/service/event?type_code=training'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 16,
    //   name: '훈련관리 등록/수정/삭제',
    //   path: '/service/event?type_code=training',
    //   url: '/service/event?type_code=training'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 17,
    //   name: '경기관리 조회',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 18,
    //   name: '경기관리 등록/수정/삭제',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 19,
    //   name: '선수관리 조회',
    //   path: '/service/player',
    //   url: '/service/player'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 20,
    //   name: '조직관리 조회',
    //   path: '/service/member',
    //   url: '/service/member'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 21,
    //   name: '조직관리 수정/삭제',
    //   path: '/service/member',
    //   url: '/service/member'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 22,
    //   name: '건강관리 영상 등록/삭제',
    //   path: '/service/health',
    //   url: '/service/health'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 23,
    //   name: '건강관리 컨텐츠 등록/삭제',
    //   path: '/service/health',
    //   url: '/service/health'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 24,
    //   name: '부상관리 영상 등록/삭제',
    //   path: '/service/injury',
    //   url: '/service/injury'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 25,
    //   name: '부상관리 컨텐츠 등록/삭제',
    //   path: '/service/injury',
    //   url: '/service/injury'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 26,
    //   name: '대입 기능',  // id: 41
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 27,
    //   name: '대입 기능 - 기간',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 28,
    //   name: '대입 기능 - 위치',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 29,
    //   name: '대입 기능 - 환경',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 30,
    //   name: '대입 기능 - 강도',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 31,
    //   name: '대입 기능 - 경기',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 32,
    //   name: '대입 기능 - 상대',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 33,
    //   name: '대입 기능 - 동작',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 34,
    //   name: '대입 기능 - 부상',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 35,
    //   name: '대입 기능 - 선수',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 36,
    //   name: '대입 기능 - 부위',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 37,
    //   name: '대입 기능 - 상황',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 38,
    //   name: '대입 기능 - 구분',
    //   path: '',
    //   url: ''
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 39,
    //   name: '훈련관리 지도자료',
    //   path: '/service/event?type_code=training',
    //   url: '/service/event?type_code=training'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 40,
    //   name: '훈련관리 선수분석',
    //   path: '/service/event?type_code=training',
    //   url: '/service/event?type_code=training'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 41,
    //   name: '경기관리 경기기록',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 42,
    //   name: '경기관리 지도자료',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 43,
    //   name: '경기관리 경기분석',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 44,
    //   name: '경기관리 선수분석',
    //   path: '/service/event?type_code=game',
    //   url: '/service/event?type_code=game'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 45,
    //   name: '조직관리 이적/발탁 요청/취소',
    //   path: '/service/member',
    //   url: '/service/member'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 46,
    //   name: '조직관리 이적/발탁 동의/취소',
    //   path: '/service/member',
    //   url: '/service/member'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 47,
    //   name: 'SGS SYSTEM GUARD 추가/삭제',
    //   path: '/service/admin',
    //   url: '/service/admin'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 48,
    //   name: 'SGS SYSTEM IoT 디바이스 추가/삭제',
    //   path: '/service/admin',
    //   url: '/service/admin'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 49,
    //   name: '데이터 제공/제외',
    //   path: '/service/admin',
    //   url: '/service/admin'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });
    // AdminService.addMenu({
    //   login_id: vm.appContext.user.login_id,
    //   uuid: vm.appContext.user.uuid,
    //   idx: 50,
    //   name: '데이터 기준값 설정',
    //   path: '/service/admin',
    //   url: '/service/admin'
    // }).then(function(res){
    //   console.log('add menu', res.data);
    // }).catch(function (e) {
    //   console.log('ERROR ' + e);
    // });

    /*
     * 데이터 관리 시작
     */
    // API 목록
    vm.adminShowApiList = function() {
      if (!$stateParams.team4_id) {
        toastr.error('팀을 선택해주십시오');
        return;
      }

      toastr.info('데이터를 불러오는 중입니다.', {
        timeOut: 60000
      });

      AdminService.getApiList({
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 23,
        parent_id: 4,
        team_id: $stateParams.team4_id
      }).then(function(res) {
        console.log('api list', res.data);
        vm.adminApiList = res.data.list;
  
        toastr.clear();
      }).catch(function (error) {
        console.log('ERROR ' + error);
      });
    };

    // API 제공/제외
    vm.adminManageApi = function(teamId, apiId, mode) {
      $ngConfirm({
        boxWidth: '30%',
        useBootstrap: false,
        title: '상태 변경',
        content: '선택하신 데이터를 ' + (mode === 'Y' ? '제공' : '제외') + '하시겠습니까?',
        scope: $scope,
        buttons: {
          confirm: {
            text: '상태 변경',
            btnClass: 'btn-blue',
            action: function (scope, button) {
  
              AdminService.manageApi({
                login_id: vm.appContext.user.login_id,
                uuid: vm.appContext.user.uuid,
                menu_id: 4,
                team_id: teamId,
                api_id: apiId,
                mode: mode
              }).then(function(res) {
                console.log('manage api', res.data);

                toastr.success('변경되었습니다. 데이터를 다시 불러옵니다.');
        
                vm.adminShowApiList();
              }).catch(function (error) {
                console.log('ERROR ' + error);
              });
  
            }
          },
          cancel: {
            text: '취소',
            btnClass: 'btn-orange',
          },
        }
      });
    };
    // 데이터 관리 끝
  }
  // 데이터 기준값 설정
  else if ($stateParams.admin_menu === 'data') {
    
  }
  // 사용자 관리
  else if ($stateParams.admin_menu === 'users') {
    // 역할 조회
    AdminService.getRoles({
      show_21c: 'Y'
    }).then(function (res) {
      console.log('roles', res.data);

      vm.adminRoles = res.data.roles;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    vm.adminUserSearchOption = 'sch_login_id';

    vm.adminUserSearch = function() {
      if (!vm.adminUserSearchValue) {
        toastr.error('검색어를 입력하십시오');
        return;
      }

      var searchOptions = {
        login_id: vm.appContext.user.login_id,
        uuid: vm.appContext.user.uuid,
        menu_id: 22,  // 사용자 관리 메뉴
        limit: 200
      };
      searchOptions[vm.adminUserSearchOption] = vm.adminUserSearchValue;

      AdminService.userList(searchOptions).then(function (res) {
        console.log('user search', res.data);

        vm.members = res.data.list;
      }).catch(function (e) {
        console.log('ERROR ' + e);
      });
    };
  }

  vm.trustAsHtml = function(value) {
    return $sce.trustAsHtml(value);
  };


}

export default {
  name: 'AdminCtrl',
  fn: AdminCtrl
};
